import React from 'react'
import { useExercise } from '../ExerciseProvider'
import { useTranslation } from '~/hooks/useTranslation'
import { RadioGroup, RadioGroupItem } from '~/lib/ui/radio-group'
import safeParse from '~/lib/safeParse'

const LinkedinVisibilitySelfAuditQuestions = ({ questions, index }) => {
  const { getResponse, updateResponse, exerciseIndex } = useExercise()
  const { t } = useTranslation('linkedin_visibility_self_audit')
  const sectionOneContent = t(`pages.${index}`)

  return (
    <div>
      {questions.map((question, index) => (
        <div
          key={index}
          className="mb-6 w-full font-roboto text-base font-medium"
        >
          <div className="flex w-full flex-col">
            <label className="!mb-1">{question.question}</label>
            <RadioGroup
              value={getResponse(exerciseIndex, question.slug) || ''}
              onValueChange={(value) =>
                updateResponse(exerciseIndex, question.slug, value)
              }
            >
              <div className="flex items-center">
                <RadioGroupItem value="yes"></RadioGroupItem>
                <label className="ml-2">{question.options.a.option}</label>
              </div>

              <div className="flex items-center">
                <RadioGroupItem value="no"></RadioGroupItem>
                <label className="ml-2">{question.options.b.option}</label>
              </div>
            </RadioGroup>
          </div>
        </div>
      ))}
      <p className="mb-4">{safeParse(sectionOneContent.reflection)}</p>
    </div>
  )
}

export default LinkedinVisibilitySelfAuditQuestions
